import styled from "styled-components";

const Wrapper
	= styled.ul`
		li {
			list-style: none;
		}


		.list-parent {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: calc(4px + .4vw) calc(6px + .6vw);
			background-color: rgba(255,255,255, .1);
			border-radius: 8px;
			cursor: pointer;
			transition: .4s ease;

			&:hover {
				background-color: rgba(255,255,255, .2);
			}

			.left {
				display: flex;
				align-items: center;
				gap: calc(4px + .4vw);

				.value {
					position: relative;
					font-size: 105%;
					text-transform: capitalize;
					color: white;
				}

				.icon-left {
					width: calc(16px + .8vw);
					height: calc(16px + .8vw);
					border-radius: calc(16px + .8vw / 2);
					background-color: #6C4B70;
					overflow: hidden;

					img {
						width: 100%;
					}
			}
			}
		}
	`

export default Wrapper
